import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {User} from "../classes/user";

@Injectable({
  providedIn: 'root'
})
export class UserService {
  user: BehaviorSubject<User> = new BehaviorSubject<User>(new User(null));
  user$: Observable<User> = this.user.asObservable();

  constructor() { }

  setUser(u: User): void {
    this.user.next(u);
  }

  getUser(): User {
    return this.user.getValue();
  }

  get getUserType(): string {
    return this.user?.getValue()?.role;
  }

  get getFullUserName(): string {
    return this.user?.getValue()?.full_name;
  }

  get getUserContact(): string {
    return this.user?.getValue()?.phone_number;
  }

  get getUserId(): number {
    return this.user?.getValue()?.staff_id;
  }
  
  get getAccessToken(): string {
    return this.user?.getValue()?.access_token;
  }


}
